import React, { useEffect, useState } from "react";
import "./Kits.css";
import DataTableComponent from "../../components/DataTable";
import {
  deleteKitManagementData,
  fetchBatchKitData,
  fetchKitssManagementData,
  setKitManagementData,
} from "../../redux/slice/KitManagementSlice";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/Common/Loader/PrimaryLoader";
import image from "../../Assets/no-img/no-image-icon.png";
import { RxTriangleDown } from "react-icons/rx";
import DeleteConFirmationModal from "../../components/Common/DeleteConFirmationModal";
import KitInfoModal from "../../components/Common/InfoModal/kitInfo";
import moment from "moment";
import CSVIcon from "../../Assets/icons/csv-icon.svg";
import PDFIcon from "../../Assets/icons/pdf-icon.svg";
import PDFDownloadIcon from "../../Assets/icons/pdf-download.svg";
import CSVDownloadIcon from "../../Assets/icons/csv-download.svg";
import { NavLink } from "react-bootstrap";
import { usePic } from "../../context/PicProvider";
import { exportCSV } from "../../utils/exportCSV";
import { underscoreCapitalize } from "../../utils/underscoreCapitalize.js";
import { toast } from "react-toastify";
import { useSocketContext } from "../../context/SocketContext.jsx";

function Kits() {
  const dispatch = useDispatch();
  const { setIsLoading } = usePic();
  const {
    batchUpdated,
    setBatchUpdated,
    currentBatchData,
    setCurrentBatchData,
  } = useSocketContext();
  const { status, KitManagementData } = useSelector(
    (state) => state.KITMANAGEMENT
  );
  const [userListModal, setUserListModal] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [modalConfirmTitle, setModalConfirmTitle] = useState("");
  const [showDropCon, setShowDropCon] = useState(false);
  const [downDrop, setDownDrop] = useState(false);
  const [customClass, setCustomClass] = useState("");
  const [removeId, setRemoveId] = useState([]);
  const [data, setData] = useState([]);

  // const removeKitHandler = async (id) => {
  //   toast.success("Kit Deleted Successfully");
  //   setDeleteConfirm(false);
  // };
  const removeKitHandler = async () => {
    setIsLoading(true);
    const res = await dispatch(deleteKitManagementData({ ids: removeId }));
    setIsLoading(false);
    if (res?.payload?.data?.status === 200) {
      dispatch(fetchKitssManagementData());
      setDeleteConfirm(false);
      setShowDropCon(false);
      setDownDrop(false);
      setRemoveId([]);
    }
  };

  const clickRowHandler = (row) => {
    setUserInfo(row);
    setUserListModal(true);
  };

  useEffect(() => {
    dispatch(fetchKitssManagementData());
  }, [dispatch]);

  useEffect(() => {
    setData(KitManagementData || []);
  }, [KitManagementData]);

  useEffect(() => {
    if (batchUpdated) {
      const filteredData = data?.map((item) => {
        if (item?._id === currentBatchData?._id) {
          return currentBatchData;
        } else {
          return item;
        }
      });
      dispatch(setKitManagementData(filteredData));
      setBatchUpdated(false);
      setCurrentBatchData({});
    }
  }, [batchUpdated]);

  const onSelectedCheckboxChange = (check) => {
    const selectedId = check?.selectedRows.map((curElm) => curElm._id);
    if (selectedId.length > 0) {
      setRemoveId(selectedId);
      setShowDropCon(true);
    } else {
      setRemoveId([]);
      setShowDropCon(false);
    }
  };

  const getCSVData = async (id) => {
    setIsLoading(true);
    try {
      const res = await dispatch(fetchBatchKitData(id));
      const data = res?.payload?.data ?? [];
      if (data.length > 0) {
        const worksheetData = data.map((item) => ({
          QR_link: item.qr_link,
        }));
        exportCSV(worksheetData);
      }
      toast.success("Downloaded successfully");
      // Handle success if needed
      return res;
    } catch (error) {
      // Handle errors
      console.error("Error fetching batch kit data:", error);
      throw error; // Optionally re-throw the error if needed
    } finally {
      setIsLoading(false);
    }
  };

  const KitColumns = [
    {
      name: "",
      width: "65px",
      cell: (row) => (
        <img
          src={row.kit_picture}
          className="products-image"
          alt="product-image"
          onError={(e) => {
            e.target.src = image;
          }}
        />
      ),
    },
    {
      name: (
        <span
          className={customClass === "1" ? "custom-span-style-for-sorting" : ""}
          onClick={() => handleCustomClassForUnderLine("1")}
        >
          BOM
        </span>
      ),
      grow: 0,
      selector: (row) => row.product_code,
      sortable: true,
    },
    {
      name: (
        <span
          className={customClass === "2" ? "custom-span-style-for-sorting" : ""}
          onClick={() => handleCustomClassForUnderLine("2")}
        >
          Product
        </span>
      ),
      minWidth: "250px",
      grow: 1,
      selector: (row) => {
        const productCode = row.product_code ?? "";
        return productCode + " " + row.product_name;
      },
      sortable: true,
    },
    {
      name: (
        <span
          className={customClass === "3" ? "custom-span-style-for-sorting" : ""}
          onClick={() => handleCustomClassForUnderLine("3")}
        >
          Created
        </span>
      ),
      width: "180px",
      selector: (row) => {
        const createdDate = row?.createdAt
          ? moment(row?.createdAt).format("DD/MM/YY HH:mm")
          : "";
        return createdDate;
      },
      sortable: true,
    },
    {
      name: (
        <span
          className={customClass === "4" ? "custom-span-style-for-sorting" : ""}
          onClick={() => handleCustomClassForUnderLine("4")}
        >
          LOT #
        </span>
      ),
      // width: "200px",
      grow: 0,
      selector: (row) => row.lot_number,
      sortable: true,
    },
    // {
    //   name: (
    //     <span
    //       className={customClass === "5" ? "custom-span-style-for-sorting" : ""}
    //       onClick={() => handleCustomClassForUnderLine("5")}
    //     >
    //       Created By
    //     </span>
    //   ),
    //   selector: (row) => row.createdBy,
    //   sortable: true,
    // },
    {
      name: "Status",
      width: "140px",
      selector: (row) => {
        const statusContent = row?.status?.toLowerCase();
        let statusColor = "";
        switch (statusContent) {
          case "ready":
            statusColor = "#359742";
            break;
          case "in_progress":
            statusColor = "#CCA300";
            break;
          default:
            statusColor = "#FF6666";
            break;
        }
        if (statusContent === "completed") {
          return (
            <div className="d-flex gap-3">
              <div className="hover-container">
                <img src={CSVIcon} alt="csv-icon" className="cursor" />
                <img
                  src={CSVDownloadIcon}
                  alt="csv-download-icon"
                  className="cursor hover-icon"
                  onClick={() => getCSVData(row?.batch_id)}
                />
              </div>
              <div className="hover-container">
                <img src={PDFIcon} alt="pdf-icon" className="cursor" />
                <NavLink
                  href={row.batch_kit_file_download_link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={PDFDownloadIcon}
                    alt="pdf-download-icon"
                    className="cursor hover-icon"
                  />
                </NavLink>
              </div>
            </div>
          );
        } else {
          return (
            <span
              className={`status ${statusColor} text-capitalize`}
              style={{ color: statusColor }}
            >
              {underscoreCapitalize(statusContent)}
            </span>
          );
        }
      },
    },
  ];

  const handleCustomClassForUnderLine = (num) => {
    setCustomClass(num);
  };

  const downIconHandler = () => {
    setDownDrop(!downDrop);
  };

  const deleteHandler = () => {
    setDeleteConfirm(true);
    setModalConfirmTitle("Are you sure you want to delete this kit ?");
  };

  if (status === "loading") {
    return (
      <div>
        <Loader />
      </div>
    );
  }
  const userData = KitManagementData || [];
  return (
    <div className="kit-management position-relative flex-grow-1">
      {userData && userData.length > 0 && showDropCon && (
        <div className="dropdown_icon_style">
          <div onClick={() => downIconHandler()}>
            <RxTriangleDown size={23} />
          </div>
          {downDrop && (
            <div className="event-box-data-user-event-listing">
              <h6 className="cursor" onClick={() => deleteHandler()}>
                Delete{" "}
              </h6>
            </div>
          )}
        </div>
      )}
      <DataTableComponent
        search={true}
        searchBy={[
          "company_name",
          "industry",
          "product_code",
          "product_name",
          "location_name",
          "area",
        ]}
        title={"Created Batches"}
        columns={KitColumns}
        data={userData}
        selectedRows
        clickedRow={clickRowHandler}
        checkboxChange={onSelectedCheckboxChange}
        placeholder="Search for batch"
      />

      {userListModal && (
        <KitInfoModal
          hide={() => setUserListModal(false)}
          show={userListModal}
          title={"Batch Information"}
          listingData={userInfo}
        />
      )}
      {deleteConfirm && (
        <DeleteConFirmationModal
          show={deleteConfirm}
          title={modalConfirmTitle}
          eventHandler={removeKitHandler}
          hide={() => setDeleteConfirm(false)}
        />
      )}
    </div>
  );
}

export default Kits;
